import { render, staticRenderFns } from "./LoglyCardStyleRelatedNotes.vue?vue&type=template&id=e9f99a42&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports